module.exports = __webpack_public_path__ + "static/3692035c0e74bb66bef4e2dd505796e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/iphone-content.jpg
// module id = 1185
// module chunks = 0